const themeBackground = `linear-gradient(130deg, #512da8 10%, rgba(5, 213, 255, 1) 85%, rgb(175, 255, 203) 100%)`;

export default themeBackground;
